import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%2C%20colorful%20comic%20book%20collage%20with%20various%20characters%2C%20warm%20vibrant%20colors%2C%20dynamic%20action%20scenes%2C%20reading%20and%20entertainment%20vibe%2C%20artistic%20composition%2C%20flat%20illustration%20style%2C%20no%20text%2C%20soft%20gradient%20background&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="可游漫画网 - 韩国漫画在线阅读"
          className="w-full h-full object-cover object-top"
        />
      </div>
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 md:px-6 w-full">
        <h1 className="font-heading text-2xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight">
          韩国漫画 · 无删减 · <span className="text-accent-400">下拉式阅读</span>
        </h1>
        <p className="text-sm md:text-lg text-white/80 max-w-2xl mb-6 md:mb-8 leading-relaxed">
          可游漫画网提供无删减韩国漫画下拉式阅读，韩漫在线免费阅读资源齐全且持续更新，
          从新作到经典应有尽有，满足多样化阅读喜好。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/love"
            className="px-8 py-3 rounded-full bg-primary-500 text-white text-sm md:text-base font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            开始阅读
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full bg-white/15 backdrop-blur-sm text-white text-sm md:text-base font-medium hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        {/* Stats */}
        <div className="flex items-center gap-6 md:gap-10 mt-8 md:mt-12">
          <div className="text-center">
            <p className="text-xl md:text-2xl font-bold text-white">12,580+</p>
            <p className="text-xs text-white/60 mt-1">漫画资源</p>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div className="text-center">
            <p className="text-xl md:text-2xl font-bold text-white">356,000+</p>
            <p className="text-xs text-white/60 mt-1">漫画章节</p>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div className="text-center">
            <p className="text-xl md:text-2xl font-bold text-white">52万+</p>
            <p className="text-xs text-white/60 mt-1">日活跃用户</p>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white/60 text-xl"></i>
      </div>
    </section>
  );
}